module.exports = __webpack_public_path__ + "img/Barcode.777872e0.svg";